export function classJoin(...classes: any[]) {
  const flattened = classes
    .filter((x) => typeof x === 'string')
    .map((str) => str.split(' '))
    .flat();
  const set = new Set(flattened);
  return Array.from(set).join(' ');
}

export default classJoin;
